export default __webpack_public_path__ + "static/media/product-06.62fe7f53.jpg";